import React, { useRef, useState, useEffect } from 'react';
import {
  IconArrowDropDown,
  IconArrowDropUp,
  Input,
  Menu,
  MenuListItem,
  INPUT_SIZES
} from 'cdk-radial';
import styled from 'styled-components';
import './DAABSubscriptions.scss';

// style the input with the cursor:pointer using styled components
const StyledInput = styled(Input)`
  cursor: pointer;
  svg {
    cursor: pointer;
  }
`;

const CMFSelectorDropdown = ({ options, storeId, value = "", isDisabled, inputId, handleCmfSelect }) => {
  const targetRef = useRef();
  const dimensionRef = useRef();
  const menuContainerRef = useRef();
  
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState({label: value, value});

  
  const handleOpen = (event) => {
    setIsOpen(true);
  };

  const handleClose = (event) => {
    setIsOpen(false);
  };

  const handleSelect = (option) => {
    setSelectedOption(option);
    handleCmfSelect(inputId, option, storeId);
    setIsOpen(false);
  };

  useEffect(() => {
    const setIsOpenFromMenu = (event) => {
      if (event.detail.ref === menuContainerRef)
        setIsOpen(event.detail.openMenu);
    };
    document.addEventListener('customMenuOpenEvent', setIsOpenFromMenu);
    return () =>
      document.removeEventListener('customMenuOpenEvent', setIsOpenFromMenu);
  }, []);

  return (
    <>
      <div
        data-testid="single-select-dropdown"
        className="cmf-selector-dropdown"
      >
        <StyledInput
          dataTestId="menu-input"
          icon={isOpen ? <IconArrowDropUp /> : <IconArrowDropDown />}
          id={inputId}
          label={''}
          labelRef={dimensionRef}
          name={inputId}
          onChange={() => {}}
          isDisabled={isDisabled}
          placeholder="CMF number"
          ref={targetRef}
          value={value}
          style={{ caretColor: 'transparent' }}
          size={INPUT_SIZES.SMALL}
          enableCustomValidation={!isDisabled}
          hasError={!isDisabled && !value}
        />
      </div>
      <Menu
        dataTestId="menu-container"
        dimensionRef={dimensionRef}
        isOpen={isOpen}
        labelRef={targetRef}
        onClose={handleClose}
        onOpen={handleOpen}
        className="cmf-selector-dropdown-menu"
        isAuto={false}
        ref={menuContainerRef}
      >
        {options?.map((option, ind) => (
          <MenuListItem
            dataTestId={`menu-item-${ind}`}
            isDisabled={option.disabled}
            isSelected={option.value === selectedOption.value}
            key={ind}
            onClick={() => handleSelect(option)}
            hideSelectedItemCheckmark={false}
          >
            {option.label}
          </MenuListItem>
        ))}
      </Menu>
    </>
  );
};
export default CMFSelectorDropdown;